import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SignalTranslationEquationList from './SignalTranslationEquationList';
import { getSignalTranslationEquation, getUserProfileWidget, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';
import { getSignalTranslationEquationThunk, setCurrentPage, setPageFilter, setSignalTranslationEquationCleanUpThunk } from '../../actions/signalTranslationEquation';

const mapStateToProps = state => {
  return {
    signalTranslationEquationManager: getSignalTranslationEquation(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state),
    currentTimezone: getCurrentTimezone(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSignalTranslationEquation: (offset, limit, filter, modelCategoryId) => getSignalTranslationEquationThunk(offset, 'SIGNALTRANSLATIONS_TAB', modelCategoryId),
      cleanUpSignalTranslationEquation: () => setSignalTranslationEquationCleanUpThunk(),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignalTranslationEquationList);
